import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LocaleService } from './locale.service';

/**
 * Shared "where does a just-authenticated user go next" decision, used by
 * both LoginComponent (password login) and SsoLoginComponent (Entra
 * ID/OIDC login) so the routing rules - admin vs eRa vs home - live in one
 * place instead of being forked between the two login entry points.
 */
@Injectable({
  providedIn: 'root'
})
export class PostLoginNavigationService {
  constructor(
    private router: Router,
    private authService: AuthService,
    private localeService: LocaleService
  ) {}

  /**
   * Redirects user to proper application page based on ones roles and
   * organization.
   *
   * - Admin users are redirected to settings page.
   * - Users who don't have e-card number or who's active organization unit
   * don't have oid are redirect to home page
   * - Others are redirect to the eRa login page
   */
  redirectToApplication(): void {
    const profile = this.authService.getUserProfile();
    if (!profile) {
      this.router.navigate(['/login']);
      return;
    }
    // Set locale based on the user active organization country.
    this.localeService.setLocale(
      profile.activeOrganizationUnit?.country || profile.language
    );
    // Redirect system admins straight to the settings, others to home page
    if (profile.systemAdmin === true) {
      this.router.navigate(['/settings/organizations']);
    } else if (profile.activeOrganizationUnit?.oid) {
      // If active organization has the oid value then redirect user to
      // eRa login, otherwise to the home page
      this.router.navigate(['/era/login']);
    } else {
      this.router.navigate(['/home']);
    }
  }
}
